export type { UserBonusTableTranslations } from "./user-bonus-table-pt-br";
export { USER_BONUS_TABLE_PT_BR } from "./user-bonus-table-pt-br";
export { USER_BONUS_TABLE_EN_US } from "./user-bonus-table-en-us";
export { USER_BONUS_TABLE_ES_MX } from "./user-bonus-table-es-mx";
export { USER_BONUS_TABLE_FR_FR } from "./user-bonus-table-fr-fr";
